import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const ActionDropdown = ({
    row,
    refresh,
    closeDropdown,
    setSelectedRow,
    openLinkModal,
    openPackageModal,
    setAddtoPlaygroundbuttonClick,
}) => {
    const [isDisable, setIsDisable] = useState();

    useEffect(() => {
        if (row.ComponentState === 'Ready to Review') {
            console.log("Row", row.ComponentState)
            setIsDisable(true);
        } else {
            setIsDisable(false);
        }
    }, [row]);

    const AddedStateUpdate = async (id) => {
        await fetch(`https://dev.appstudioltts.com/api/linkstateupdate/updatedata/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ ComponentState: "Added to Playground" }),
        });
    };

    const AddToPlayground = async () => {
        try {
            closeDropdown();
            toast.info("Adding to Playground...");
            await AddedStateUpdate(row._id);

            const [categoryRes, componentRes] = await Promise.all([
                fetch("https://prod.appstudioltts.com/api/auto/fetch-data"),
                fetch("https://prod.appstudioltts.com/api/linkstateupdate/fetchdata")
            ]);
            const categoryData = await categoryRes.json();
            const componentData = await componentRes.json();

            const matchingApiData = categoryData[0].AutoData.find((item) =>
                item.label.replace(/\s/g, '').toLowerCase() === row.Category.toLowerCase()
            );

            const matchingComponent = componentData.find((item) =>
                item.ComponentName === row.ComponentName && item.Category === row.Category
            );

            let UpdateComponentDetails;
            const isReact = row.Technology.toLowerCase() === 'react';

            if (isReact) {
                UpdateComponentDetails = {
                    AutoData: [
                        {
                            label: matchingApiData ? matchingApiData.label : row.Category,
                            rootPath: matchingApiData ? matchingApiData.rootPath : `/${row.ComponentName.replace(/\s/g, '')}`,
                            hostedurlVal: matchingApiData ? matchingApiData.hostedurlVal : `${row.ComponentName.replace(/\s/g, '')}Img`,
                            chartType: matchingApiData ? matchingApiData.chartType : row.ComponentName.replace(/\s/g, '_'),
                            type: matchingApiData ? matchingApiData.type : (row.type === 'nonui' ? 'ui' : row.type),
                            packageName: matchingApiData ? matchingApiData.packageName : `@ltts-dtp-appstudio/react-${row.ComponentName.trim().toLowerCase()}`,
                            libraryGitURL: matchingApiData ? matchingApiData.libraryGitURL : row.PublishPackageUrl,
                            libraryDocURL: "https://webappstudio-react.visualstudio.com/WebAppStudio-React/_wiki/wikis/WebAppStudio-React.wiki/58/ReferenceDoc-HowToUseAppStudioLibraries",
                            subComponents: [
                                {
                                    subCompoLabel: matchingComponent.ComponentName,
                                    routePath: matchingComponent.ComponentName.replace(/\s/g, ''),
                                    hostedurlVal: `${matchingComponent.ComponentName.replace(/\s/g, '')}Img`,
                                    TypeFilter: "",
                                    Icon: row.UploadIcon,
                                    activeIcon: row.UploadBGIcon,
                                    designDocUrl: row.designDocuments
                                }
                            ]
                        }
                    ]
                };
            } else {
                UpdateComponentDetails = {
                    AutoData: [
                        {
                            label: row.Category,
                            rootPath: `/${row.ComponentName.replace(/\s/g, '')}`,
                            hostedurlVal: `${row.ComponentName.replace(/\s/g, '')}Img`,
                            chartType: `${row.ComponentName.replace(/\s/g, '_')}`,
                            type: row.type === "nonui" ? "ui" : row.type,
                            subComponents: [
                                {
                                    subCompoLabel: matchingComponent.ComponentName,
                                    routePath: matchingComponent.ComponentName.replace(/\s/g, ''),
                                    hostedurlVal: `${matchingComponent.ComponentName.replace(/\s/g, '')}Img`,
                                    TypeFilter: "",
                                    Icon: matchingComponent.ComponentName.replace(/\s/g, ''),
                                    activeIcon: `${matchingComponent.ComponentName.replace(/\s/g, '')}Active`,
                                    designDocUrl: row.designDocuments
                                }
                            ]
                        }
                    ]
                };
            }

            const apiURL = isReact
                ? "https://prod.appstudioltts.com/api/auto/add-subcomponent"
                : "https://prod.appstudioltts.com/api/angularauto/add-subcomponent";

            const res = await fetch(apiURL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(UpdateComponentDetails),
            });

            if (res.status === 200) {
                setAddtoPlaygroundbuttonClick?.({
                    addingState: true,
                    selectedRowId: row._id
                });

                Swal.fire({
                    title: "Information!",
                    html: `For instructions on adding Component to the Playground, click 
          <a href="https://dev.azure.com/WebAppStudio-React/WebAppStudio-React/_wiki/wikis/WebAppStudio-React.wiki/293/Steps-to-Add-Component-to-Playground" target="_blank">here</a> `,
                    icon: "info",
                    confirmButtonText: "OK",
                });
            } else {
                toast.error("Failed to add component to playground.");
            }
        } catch (error) {
            console.error("Playground error:", error);
            toast.error("Something went wrong while adding to Playground.");
        }
    };

    const handleDirectSubmit = async () => {
        try {
            const updated = { ...row, ComponentState: 'Submitted' };

            const res = await fetch("https://dev.appstudioltts.com/api/linkstateupdate/submitdata", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updated),
            });

            if (res.ok) {
                toast.success("Component submitted");
                refresh();
            } else {
                toast.error("Failed to submit");
            }
        } catch (err) {
            console.error("Submit error:", err);
            toast.error("Error submitting");
        }

        closeDropdown();
    };

    const handleRemove = async () => {
        try {
            await fetch("https://dev.appstudioltts.com/api/request/community-request", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ComponentName: row.ComponentName,
                    ComponentDetails: row.ComponentDetails,
                    Category: row.Category,
                    Technology: row.Technology,
                    ComponentType:row.ComponentType
                }),
            });

            await fetch(`https://dev.appstudioltts.com/api/linkstateupdate/removedata/${row._id}`, {
                method: "DELETE",
            });

            toast.success("Component removed");
            refresh();
        } catch (error) {
            console.error("Error removing row:", error);
            toast.error("Failed to remove component");
        }

        closeDropdown();
    };

    const handleSubmitClick = () => {
        if (row.ComponentState === 'In Progress') {
            setSelectedRow(row);
            openLinkModal(); // opens ReadyToPublishModal
        } else if (row.ComponentState === 'Ready to Publish') {
            setSelectedRow(row);
            openPackageModal(); // opens PublishPackageModal
        } else {
            handleDirectSubmit(); // fallback direct submit
        }

        closeDropdown();
    };

    return (
        <div>
            {row.ComponentState !== "Adding to Playground" && <div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow z-30">
                {row.ComponentState === "Published" ? (
                    <button
                        onClick={AddToPlayground}
                        className="w-full px-3 py-1 text-left text-blue-600 hover:bg-gray-100"
                    >
                        ✔ Add to Playground
                    </button>
                ) : (
                    <div>
                        <button
                            onClick={handleSubmitClick}
                            className={`w-full px-3 py-1 text-left text-green-600 hover:bg-gray-100 ${isDisable ? 'bg-slate-300 text-green-400 cursor-not-allowed' : ''}`}
                            disabled={isDisable}
                        >
                            ✔ SUBMIT
                        </button>
                        <button
                            onClick={handleRemove}
                            className="w-full px-3 py-1 text-left text-red-600 hover:bg-gray-100"
                        >
                            ✖ REMOVE
                        </button>
                    </div>
                )}
            </div>}
        </div>
    );
};

export default ActionDropdown;
